/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import BottomSpace from 'components/common/BottomSpace';
import { useTranslation } from 'react-i18next';
import PartnerCard from 'components/card/PartnerCard';
import { getListPartner } from 'services/property.service';
import { delayNavigate, isSuccessCode } from 'utils/common';
import { BranchType } from 'types/property.type';

type Props = {};

export default function PartnerContainer({}: Props) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [listPartner, setListPartner] = useState<BranchType[]>([]);

  const getPartner = async () => {
    const response = await getListPartner();
    const { code, data } = response?.data;
    if (isSuccessCode(code)) {
      setListPartner(data);
    }
    delayNavigate(() => setIsLoading(false));
  };

  useEffect(() => {
    getPartner();
  }, []);

  return (
    <div className={styles.wrapper}>
      <p
        className="color-black font-xl font-bold"
        style={{ textAlign: 'left', lineHeight: 'var(--font-xxl)' }}
      >
        {t('title.your-partners')}
      </p>

      <div className={styles.listPartner}>
        {isLoading ? (
          <>
            <PartnerCard isSkeleton />
            <PartnerCard isSkeleton />
          </>
        ) : (
          listPartner?.map((partner) => {
            return (
              <PartnerCard
                key={partner.id}
                branchName={partner?.name}
                branchImgUrl={partner?.branchDetail?.appLogo}
                numberOfBuilding={partner?.buildings?.length}
                listBuilding={partner?.buildings}
              />
            );
          })
        )}
      </div>
      <BottomSpace />
    </div>
  );
}
